import {
  ACTIVATING_GOOGLE_TAG_MANAGER_REQUEST, ACTIVATING_GOOGLE_TAG_MANAGER_SUCCEDDED, ACTIVATING_GOOGLE_TAG_MANAGER_FAILED,
  UPDATING_GOOGLE_TAG_MANAGER_REQUEST, UPDATING_GOOGLE_TAG_MANAGER_SUCCEDDED, UPDATING_GOOGLE_TAG_MANAGER_FAILED,
} from '../actionTypes.jsx';
import {activatingIntegrationSuccedded } from '../integrations';
import axios from 'axios';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const GOOGLE_TAG_MANAGER_BASE_URL = `${apiUrl}/api/2.0/integrations/google-tag-manager`;

export function activateAccount(configuration){
  return function (dispatch) {
    dispatch(activatingAccount());

    return axios({
      method: 'POST',
      url: GOOGLE_TAG_MANAGER_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(activatingAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
      return response.data;
    })
    .catch(error =>
      dispatch(activatingAccountFailed(error.errors))
    )
  }
}

function activatingAccount(){
  return {
    type: ACTIVATING_GOOGLE_TAG_MANAGER_REQUEST,
    payload: {}
  }
}

function activatingAccountSuccedded(json){
  return {
    type: ACTIVATING_GOOGLE_TAG_MANAGER_SUCCEDDED,
    payload: json
  }
}

function activatingAccountFailed(error){
  return {
    type: ACTIVATING_GOOGLE_TAG_MANAGER_FAILED,
    payload: error
  }
}

/**
* Update google tag manager configuration
*/
export function updateTagManagerConfiguration(configuration){
  return function (dispatch) {
    dispatch(updatingGoogleTagManagerConfiguration());

    return axios({
      method: 'PUT',
      url: GOOGLE_TAG_MANAGER_BASE_URL,
      data: configuration
    })
    .then((response) => {
      dispatch(updatingGoogleTagManagerConfigurationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(updatingGoogleTagManagerConfigurationFailed(error.errors))
    )
  }
}

function updatingGoogleTagManagerConfiguration(){
  return {
    type: UPDATING_GOOGLE_TAG_MANAGER_REQUEST,
    payload: {}
  }
}

function updatingGoogleTagManagerConfigurationSuccedded(json){
  return {
    type: UPDATING_GOOGLE_TAG_MANAGER_SUCCEDDED,
    payload: json
  }
}

function updatingGoogleTagManagerConfigurationFailed(error){
  return {
    type: UPDATING_GOOGLE_TAG_MANAGER_FAILED,
    payload: error
  }
}